import React from "react";
import {newModelWith} from "../reducers/models";

export function registrationAttributes(values = {}) {
    const schema = {
        firstName: React.PropTypes.string,
        lastName: React.PropTypes.string,
        email: React.PropTypes.string,
        companyId: React.PropTypes.string,
        jobRole: React.PropTypes.string,
        regulatingAuthority: React.PropTypes.string,
        city: React.PropTypes.string
    };
    const defaults = {
        firstName: null,
        lastName: null,
        email: null,
        companyId: null,
        jobRole: null,
        regulatingAuthority: null,
        city: null
    };

    return newModelWith(values, defaults, schema);
}

export function userDetailsAttributes(values = {}) {
    const schema = {
        jobRole: React.PropTypes.string,
        regulatingAuthority: React.PropTypes.string
    };
    const defaults = {
        jobRole: null,
        regulatingAuthority: null
    };

    return newModelWith(values, defaults, schema);
}

export function authenticatedUser(values = {}) {
    const schema = {
        userId: React.PropTypes.string,
        username: React.PropTypes.string,
        topLevelRole: React.PropTypes.string
    };
    const defaults = {
        userId: null,
        username: null,
        topLevelRole: null
    };

    return newModelWith(values, defaults, schema);
}



/** WEBPACK FOOTER **
 ** ./src/main/javascript/authentication/models.js
 **/